/**
 * @flow
 * @relayHash fc9046b544b376ed90b7e467373661c5
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type AmazonPayPayloadInput = {|
  orderId: string
|};
export type AmazonPayPayloadMutationVariables = {|
  input: AmazonPayPayloadInput
|};
export type AmazonPayPayloadMutationResponse = {|
  +amazonPayPayload: ?{|
    +payload: string,
    +signature: string,
    +publicKeyId: string,
  |}
|};
export type AmazonPayPayloadMutation = {|
  variables: AmazonPayPayloadMutationVariables,
  response: AmazonPayPayloadMutationResponse,
|};
*/


/*
mutation AmazonPayPayloadMutation(
  $input: AmazonPayPayloadInput!
) {
  amazonPayPayload(input: $input) {
    payload
    signature
    publicKeyId
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "AmazonPayPayloadInput!",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "amazonPayPayload",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "AmazonPayPayloadPayload",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "payload",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "signature",
        "args": null,
        "storageKey": null
      },
      {
        "kind": "ScalarField",
        "alias": null,
        "name": "publicKeyId",
        "args": null,
        "storageKey": null
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "AmazonPayPayloadMutation",
    "type": "RootMutationType",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "AmazonPayPayloadMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v1/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "AmazonPayPayloadMutation",
    "id": null,
    "text": "mutation AmazonPayPayloadMutation(\n  $input: AmazonPayPayloadInput!\n) {\n  amazonPayPayload(input: $input) {\n    payload\n    signature\n    publicKeyId\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'ba901b21e57ad5692b2c47e3c50a7347';

module.exports = node;
